/* Pashion: Category slider (sections/section-category-slider.liquid).
 * Prev/next arrows scroll the track by most of its visible width and are
 * disabled at either end. */
!function() {
  'use strict';

  customElements.get('category-slider') || customElements.define('category-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-category-slider-track]');
      this.prev = this.querySelector('[data-category-slider-prev]');
      this.next = this.querySelector('[data-category-slider-next]');
      if (!this.track || !this.prev || !this.next) return;

      this.update = this.update.bind(this);
      this.onPrev = () => this.scrollByPage(-1);
      this.onNext = () => this.scrollByPage(1);

      this.prev.addEventListener('click', this.onPrev);
      this.next.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.update, {passive: true});
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);

      // Start with the current collection's link in view.
      const current = this.track.querySelector('[aria-current="page"]');
      if (current) {
        const trackBox = this.track.getBoundingClientRect();
        const itemBox = current.getBoundingClientRect();
        if (itemBox.right > trackBox.right || itemBox.left < trackBox.left) {
          this.track.style.scrollBehavior = 'auto';
          this.track.scrollLeft += itemBox.left - trackBox.left;
          this.track.style.removeProperty('scroll-behavior');
        }
      }

      this.update();
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.prev.removeEventListener('click', this.onPrev);
      this.next.removeEventListener('click', this.onNext);
      this.track.removeEventListener('scroll', this.update);
      this.resizeObserver.disconnect();
    }

    scrollByPage(direction) {
      this.track.scrollBy({left: direction * this.track.clientWidth * 0.8});
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollLeft >= max - 1;
    }
  });
}();
